import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'components/ui/button';
import { XCircle } from 'lucide-react';
import { useTheme } from 'components/core/theme-provider';
import { useTranslation } from 'react-i18next';
import groupLight from '../../assets/images/selise-ai-logo.svg';
import groupDark from '../../assets/images/selise-ai-logo-dark.svg';

export function PaymentCancelledPage() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { theme } = useTheme();

    const handleTryAgain = () => {
        navigate('/identity-management', {
            state: { from: '/payment-cancelled' }
        });
    };

    return (
        <div className="min-h-screen bg-background flex items-center justify-center p-4 w-full">
            <div className="max-w-2xl w-full text-center space-y-8">
                {/* Logo */}
                <div className="flex justify-center mb-8">
                    <img
                        src={theme === 'dark' ? groupDark : groupLight}
                        alt="SeliseAI"
                        className="h-10 w-40"
                    />
                </div>

                {/* Cancelled Icon */}
                <div className="flex justify-center">
                    <div className="w-[334px] h-[334px] flex items-center justify-center">
                        <XCircle className="w-48 h-48 text-destructive" strokeWidth={1} />
                    </div>
                </div>

                {/* Content */}
                <div className="space-y-8">
                    <div className="space-y-4">
                        {/* Title */}
                        <h1 className="text-3xl font-bold leading-[48px] text-foreground font-sans">
                            {t('PAYMENT_CANCELLED')}
                        </h1>

                        {/* Description */}
                        <p className="text-xl font-normal leading-[30px] text-muted-foreground font-sans">
                            {t('PAYMENT_CANCELLED_DESCRIPTION')}
                        </p>
                    </div>

                    {/* Button */}
                    <div className="flex justify-center">
                        <Button
                            onClick={handleTryAgain}
                            className="w-[330px] h-[46px] bg-primary hover:bg-primary-600 text-primary-foreground font-semibold text-[15px] leading-[26px] rounded-md px-4 py-2.5 transition-colors"
                        >
                            {t('TRY_AGAIN', 'Try again')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}